import * as Layer from 'effect/Layer';
import { AppLayer } from '@/api/client';
import { AuthServiceLive } from './auth/auth.service';
import { ExpenseServiceLive } from './expenses/expense.service';
import { GroupServiceLive } from './groups/group.service';
import { CategoryServiceLive } from './categories/category.service';
import { UserServiceLive } from './user/user.service';
import { StorageLayer } from './storage/storage.service';
import { NetworkLayer } from './network/network.service';
import { SyncLayer } from './sync/sync.service';
import { RepositoryEventBusLive } from '@/repositories/reactive-base.repository';

// Combine all base services (no dependencies)
const BaseLayer = Layer.mergeAll(
  StorageLayer,
  NetworkLayer,
  AppLayer,
  RepositoryEventBusLive
);

// API-dependent services
const ApiServicesLayer = Layer.mergeAll(
  AuthServiceLive,
  ExpenseServiceLive,
  GroupServiceLive,
  CategoryServiceLive,
  UserServiceLive
);

// Provide base layer to API services
const ApiServicesWithDeps = Layer.provide(ApiServicesLayer, BaseLayer);

// SyncLayer needs both Storage and Network
const SyncLayerWithDeps = Layer.provide(SyncLayer, BaseLayer);

// Combine everything into the main layer
export const MainLayer = Layer.mergeAll(
  BaseLayer,
  ApiServicesWithDeps,
  SyncLayerWithDeps
);

// Export ServicesLayer for backward compatibility
export const ServicesLayer = MainLayer;

// Export individual layers for testing
export {
  AuthServiceLive,
  ExpenseServiceLive,
  GroupServiceLive,
  CategoryServiceLive,
  UserServiceLive,
  StorageLayer,
  NetworkLayer,
  SyncLayer,
};